import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Alert, Button} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {getSlotMediaStatus} from '../api';

const labels = {
  complete: 'Elaborazione completata', partial: 'Evento parziale', failed: 'Elaborazione fallita',
  processing: 'Elaborazione / pubblicazione in corso', waiting: 'In attesa / nuovo tentativo',
  cancelled: 'Evento annullato', available: 'Video disponibile; completezza non certificata',
  unknown: 'Stato di elaborazione non disponibile'
};

export function SlotMediaStatus({slotId, token}) {
  const {t} = useTranslation();
  const [result, setResult] = useState(null);
  const [error, setError] = useState(false);
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    let mounted = true;
    let timer;
    setResult(null);
    setError(false);
    if (!slotId || !token) return undefined;
    const load = async () => {
      const response = await getSlotMediaStatus(slotId, token);
      if (!mounted) return;
      if (response.status !== 200) {
        setError(true);
        return;
      }
      setResult(response.json);
      setError(false);
      if (['waiting', 'processing', 'unknown'].includes(response.json.status)) {
        timer = setTimeout(load, 15000);
      }
    };
    load();
    return () => { mounted = false; clearTimeout(timer); };
  }, [slotId, token, revision]);
  if (!slotId || (!result && !error) || (result && result.status === 'not_requested')) return null;
  const label = status => t(`MEDIA_STATUS_${status.toUpperCase()}`, labels[status] || labels.unknown);
  return <Alert role="status" variant={error || (result && result.status === 'partial') ? 'warning'
    : result && result.status === 'failed' ? 'danger' : result && result.status === 'complete' ? 'success' : 'info'}>
    <strong>{error ? t('MEDIA_STATUS_LOAD_ERROR', 'Impossibile aggiornare lo stato video.') : label(result.status)}</strong>
    <Button size="sm" variant="link" onClick={() => setRevision(revision + 1)}>
      {t('MEDIA_STATUS_REFRESH', 'Aggiorna stato')}
    </Button>
    {result && <ul className="mb-1">
      {result.cameras.map(camera => <li key={camera.cameraId}>
        <strong>{camera.name} ({camera.cameraId})</strong>: {label(camera.status)}.
        {camera.videoAvailable && <> {t('MEDIA_STATUS_PLAYABLE', 'Video disponibile')}: {Math.round(camera.durationSeconds)} s.</>}
        {camera.missingSeconds > 0 && <> {t('MEDIA_STATUS_MISSING', 'Intervalli non registrati (incluso avvio)')}: {camera.missingSeconds} s.</>}
        {camera.trackingUnavailable && <> {t('MEDIA_STATUS_NO_TRACKING', 'Regia automatica non disponibile; panoramica consultabile manualmente.')}</>}
        {camera.errorCode && <> <code>{camera.errorCode}</code></>}
      </li>)}
    </ul>}
    {result && result.status === 'partial' && <small>{t('MEDIA_STATUS_PARTIAL_HELP',
      'I video disponibili restano utilizzabili. Possono mancare parti della registrazione o la regia automatica; non viene inserito video nero.')}</small>}
  </Alert>;
}

export default connect(({login: {token}}) => ({token}))(SlotMediaStatus);
